export default __webpack_public_path__ + "static/media/Snd5.bc93bb4a.mp3";